import { ListsDashboardSourceEnum } from '@/bundles/App/enums';
import { IListsDashboardsState } from '@/bundles/Pipeline/types';
import { getDefaultAvailabilitiesSlice, getDefaultComparablesSlice, getDefaultDealsSlice, getDefaultPipelineSlice } from '@/store/modules/listsDashboards/helpers';

const state = (): IListsDashboardsState => ({
  [ListsDashboardSourceEnum.pipeline]: getDefaultPipelineSlice(),
  [ListsDashboardSourceEnum.deals]: getDefaultDealsSlice(),
  [ListsDashboardSourceEnum.availabilities]: getDefaultAvailabilitiesSlice(),
  [ListsDashboardSourceEnum.comparables]: getDefaultComparablesSlice(),
});

export default state;
